// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuctionModalController from "./auction_modal_controller"
application.register("auction-modal", AuctionModalController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ContactPreferenceController from "./contact_preference_controller"
application.register("contact-preference", ContactPreferenceController)

import CustomerFlowTrackingController from "./customer_flow_tracking_controller"
application.register("customer-flow-tracking", CustomerFlowTrackingController)

import EstimateModalController from "./estimate_modal_controller"
application.register("estimate-modal", EstimateModalController)

import EstimateProgressController from "./estimate_progress_controller"
application.register("estimate-progress", EstimateProgressController)

import FloatingPhoneCtaController from "./floating_phone_cta_controller"
application.register("floating-phone-cta", FloatingPhoneCtaController)

import FormErrorFocusController from "./form_error_focus_controller"
application.register("form-error-focus", FormErrorFocusController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LiffCallbackController from "./liff_callback_controller"
application.register("liff-callback", LiffCallbackController)

import LiffInteractionController from "./liff_interaction_controller"
application.register("liff-interaction", LiffInteractionController)

import LiffPhotoGuideController from "./liff_photo_guide_controller"
application.register("liff-photo-guide", LiffPhotoGuideController)

import LiffSessionController from "./liff_session_controller"
application.register("liff-session", LiffSessionController)

import LiffWindowController from "./liff_window_controller"
application.register("liff-window", LiffWindowController)

import LocationSuggestController from "./location_suggest_controller"
application.register("location-suggest", LocationSuggestController)

import LpEstimateController from "./lp_estimate_controller"
application.register("lp-estimate", LpEstimateController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhotoLibraryCropController from "./photo_library_crop_controller"
application.register("photo-library-crop", PhotoLibraryCropController)

import PurchaseResultsCarouselController from "./purchase_results_carousel_controller"
application.register("purchase-results-carousel", PurchaseResultsCarouselController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SiteMenuController from "./site_menu_controller"
application.register("site-menu", SiteMenuController)

import VehicleSuggestController from "./vehicle_suggest_controller"
application.register("vehicle-suggest", VehicleSuggestController)
